//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Motion.js";
import "../no/Object.js";
import "../Motion/Motion.MotionSession.js";
let d=[[],[[["workPart","fileName","namingRule","addString","reportToInfoWindow","replaceExistingElements","optionInvalidElements"],"ImportMdf",{},7,0],[["workPart","fileName","namingRule","appendixString","reportToInfoWindow"],"ImportXML",{},5,0],[["compOcc","motionPart","workPart","namingRule","appendixString","reportToInfoWindow","abortOnFailure"],"ImportFromSubassembly",{},7,0]],[]];
SPLM.Motion.MechanismImport = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Motion.MechanismImport";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Motion.MechanismImport.NamingRule = Object.freeze({
    "None" : "None", "AddPrefix" : "AddPrefix", "AddSuffix" : "AddSuffix"});

SPLM.Motion.MechanismImport.InvalidElements = Object.freeze({
    "Revert" : "Revert", "Skip" : "Skip"});

export default SPLM;